import { createContext, JSX, useState } from "react";

interface UiStatsCollapseContextProps {
  collapseAll: () => void;
  collapseCategory: (category: string) => void;
  expandedCategories: string[];
  expandCategory: (category: string) => void;
}

export const UiStatisticsCollapseContext = createContext<Partial<UiStatsCollapseContextProps>>({});

export const UiStastiticsCollapseContextProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [expandedCategories, setExpandedCategories] = useState<string[]>([]);

  const collapseAll = () => {
    setExpandedCategories([]);
  }

  const collapseCategory = (category: string) => {
    const index = expandedCategories.findIndex((ti) => ti === category);
    const newTiles = [...expandedCategories]
    newTiles.splice(index, 1)
    setExpandedCategories(newTiles);
  }

  const expandCategory = (category: string) => {
    if (!expandedCategories.includes(category)) {
      setExpandedCategories(expandedCategories.concat(category));
    }
  }

  return (
    <UiStatisticsCollapseContext.Provider
      value={{
        collapseAll,
        collapseCategory,
        expandCategory,
        expandedCategories,
      }}
    >
      {children}
    </UiStatisticsCollapseContext.Provider>
  );
};
